module.exports = {
  background: '#61d3d8', // Containers
  backgroundDark: '#002855', // Background

  text: '#333333',

  primary: '#537dcc', // Image Subtitles
  primaryLight: '#499094', //Underlines
  primaryDark: '#023E7D', // Background

  secondary: '#001233', // Background
  // secondaryLight: '#ff79b0',
  // secondaryDark: '#c60055',
};

/*
  background: '#FFFFFF',
  backgroundDark: '#f0e6f6',

  text: '#333333',

  primary: '#7c37ad',
  primaryLight: '#ae66df',
  primaryDark: '#4b007d',

  secondary: '#ff4081',
  secondaryLight: '#ff79b0',
  secondaryDark: '#c60055',
*/
